@if (!authService.isAuthenticated() || currentRoute === '/lock' || currentRoute.startsWith('/deca/edit/')) {
  <div class="auth-container" [class.public-deca-container]="currentRoute.startsWith('/deca/edit/')">
    <router-outlet></router-outlet>
  </div>
} @else {
  <mat-sidenav-container class="sidenav-container" [class.handset]="handset()" [class.rail]="rail()">
    <mat-sidenav
      #drawer
      class="sidenav"
      fixedInViewport
      [attr.role]="handset() ? 'dialog' : 'navigation'"
      [mode]="handset() ? 'over' : 'side'"
      [opened]="!handset()">
      <a class="workspace-brand" routerLink="/dashboard" (click)="closeSidenavOnHandset(drawer)" [attr.aria-label]="'nav.dashboard' | translate">
        <img [src]="sidebarLogo" alt="" class="sidebar-logo">
        <span class="brand-text"><span class="innporting-wordmark">Innporting</span><span class="product-name">TMS</span></span>
      </a>
      <nav class="nav-list" [attr.aria-label]="'nav.transport-management' | translate">
        @for (item of visibleNavigationItems(); track item.route) {
          <!-- La acción rápida va como hermano (posicionado encima), nunca anidada en el link -->
          <div class="nav-row" [class.with-action]="!!item.action">
            <a [routerLink]="item.route"
              [class.active]="isActive(item)"
              [attr.aria-current]="isActive(item) ? 'page' : null"
              [matTooltip]="item.translationKey | translate"
              [matTooltipDisabled]="!rail() || handset()"
              matTooltipPosition="right"
              matTooltipClass="sidebar-tooltip"
              (click)="closeSidenavOnHandset(drawer)"
              class="nav-item">
              <mat-icon class="nav-icon" [fontSet]="item.fontSet || 'material-icons'">{{ item.icon }}</mat-icon>
              <span class="nav-text">{{ item.translationKey | translate }}</span>
            </a>
            @if (item.action; as action) {
              <!-- appTopLayerAction: en el top layer para poder pulsarlo con modales abiertos -->
              <button type="button"
                      class="nav-action"
                      appTopLayerAction
                      [matTooltip]="action.tooltipKey | translate"
                      [attr.aria-label]="action.tooltipKey | translate"
                      (click)="$event.stopPropagation(); action.run()">
                <mat-icon>{{ action.icon }}</mat-icon>
              </button>
            }
          </div>
        }
      </nav>
      <!-- Acciones de sesión al pie (como inn-dash), visibles también con la barra contraída. El perfil se abre desde la foto. -->
      <div class="sidebar-session">
        <button type="button" class="nav-item" (click)="lock()"
                [matTooltip]="'nav.lock' | translate" [matTooltipDisabled]="!rail() || handset()" matTooltipPosition="right" matTooltipClass="sidebar-tooltip">
          <mat-icon class="nav-icon">lock</mat-icon>
          <span class="nav-text">{{ 'nav.lock' | translate }}</span>
        </button>
        <button type="button" class="nav-item" (click)="logout()"
                [matTooltip]="'nav.logout' | translate" [matTooltipDisabled]="!rail() || handset()" matTooltipPosition="right" matTooltipClass="sidebar-tooltip">
          <mat-icon class="nav-icon">logout</mat-icon>
          <span class="nav-text">{{ 'nav.logout' | translate }}</span>
        </button>
      </div>
    </mat-sidenav>
    <mat-sidenav-content>
      <header class="app-header">
        <button type="button" class="header-toggle"
                [attr.aria-label]="(handset() ? 'nav.open-menu' : rail() ? 'nav.expand-sidebar' : 'nav.collapse-sidebar') | translate"
                [attr.aria-expanded]="handset() ? drawer.opened : !rail()"
                (click)="handset() ? drawer.toggle() : toggleRail()">
          <svg class="sidebar-toggle-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <rect x="3.5" y="4.5" width="17" height="15" rx="3"/><path d="M9 4.5v15"/>
            @if (rail() && !handset()) { <path d="m13 10 2 2-2 2"/> } @else { <path d="m15 10-2 2 2 2"/> }
          </svg>
        </button>
        <h1 class="header-title">{{ getPageTitle() | translate }}</h1>
        <div class="header-actions">
          @if (!environment.production){
            <button mat-icon-button (click)="deathStarOpen = !deathStarOpen" title="Death Star Panel" aria-label="Death Star Panel">
              <mat-icon svgIcon="death-star"></mat-icon>
            </button>
          }
          <app-language-selector></app-language-selector>
          <app-notification-bell></app-notification-bell>
          <!-- La foto lleva directa al perfil; bloquear y cerrar sesión están al pie de la barra lateral. -->
          <a class="profile-trigger" routerLink="/profile"
             [class.active]="currentRoute.startsWith('/profile')"
             [attr.aria-current]="currentRoute.startsWith('/profile') ? 'page' : null"
             [attr.aria-label]="'nav.profile' | translate"
             [matTooltip]="'nav.profile' | translate">
            @if (usersService.me(); as me) {
              <app-user-avatar [accountId]="me.id" [name]="(me.name || '') + ' ' + (me.surname || '')" [size]="34"></app-user-avatar>
            } @else {
              <mat-icon aria-hidden="true">account_circle</mat-icon>
            }
          </a>
        </div>
      </header>
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
  @if (deathStarOpen) {
    <app-dev-tools (closed)="deathStarOpen = false"></app-dev-tools>
  }
  <app-dev-bottom-bar></app-dev-bottom-bar>
  <!-- Toasts de notificaciones: pila fija arriba a la derecha, fuera del sidenav-container -->
  <app-notification-toasts></app-notification-toasts>
}
